module.exports = __webpack_public_path__ + "img/3EA78C67.c6afa7ee.png";